import * as z from "zod";

/** Saves whether an SMS campaign uses Recover non-subscriber outreach (on unless opted out). */
export const optInToRecoverSmsOutreach = {
  name: "optInToRecoverSmsOutreach" as const,
  input: z.object({ campaignId: z.string(), enabled: z.boolean() }),
  output: z.object({ enabled: z.boolean() }),
};
